import React from 'react'
import HeaderCard from './HeaderCard'

import '../css/TopSection.css'
// import bgVideo from '../videos/v3.mp4'


const TopSection = () => {
    return (
        <div className="d-flex flex-column top-section" id="home">
            <HeaderCard />
            {/* <video autoPlay muted loop src={bgVideo} className="topSectionBg"/> */}
            <div className="angledBg"></div>
        </div>
    )
}

export default TopSection
